import { useEffect, useRef, useState } from "react";

export const EASE = [0.76, 0, 0.24, 1];

export function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal ${inView ? "in-view" : ""} ${className}`} style={{ "--d": `${delay}s` }}>
      {children}
    </div>
  );
}

/* Masked line reveal — pure CSS animation on mount (used for the hero) */
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="mask-line">
      <span className={className} style={{ "--d": `${delay}s` }}>
        {children}
      </span>
    </span>
  );
}
